export const firebaseConfig = {
    // apiKey: "AIzaSyCmIw6ncaBDcNaY8pMaGTrc9AiKm-PAKpA",
    // authDomain: "mionosuke-testdata.firebaseapp.com",
    // projectId: "mionosuke-testdata",
    // storageBucket: "mionosuke-testdata.appspot.com",
    // messagingSenderId: "89588391401",
    // appId: "1:89588391401:web:5e0c2a553ec3d577023f78",
    // measurementId: "G-PN44ZFKNMC"

    apiKey: "AIzaSyCaSJopvz3CBeK29fQ03QwP5NzUXY6nOsk",
    authDomain: "jpn-trad.firebaseapp.com",
    projectId: "jpn-trad",
    storageBucket: "jpn-trad.appspot.com",
    messagingSenderId: "644491309825",
    appId: "1:644491309825:web:16aa2e1dba60554342a100",
    measurementId: "G-5Q6H66NS5W"
};